import {language} from './env'
import Vue from 'vue'
let path ="";
if(language=='cn'){
   path = './page/cn/';
}else if(language=='en'){
   path = './page/en/';
}

const LOGIN_TEXT = require(path+'login/index');
const REGISTER_TEXT = require(path+'register/index');
const ERROR_TEXT = require(path+'error/index');
const AGENT_TEXT = require(path+'index/agent/index');

const APPLY_INDEX_TEXT = require(path+'apply/index');
const APPLY_STEP1_TEXT = require(path+'apply/step1/index');
const APPLY_STEP2_TEXT = require(path+'apply/step2/index');
const APPLY_STEP3_TEXT = require(path+'apply/step3/index');
const APPLY_STEP4_TEXT = require(path+'apply/step4/index');
const APPLY_STEP5_TEXT = require(path+'apply/step5/index');
const APPLY_AREA_TEXT = require(path+'apply/area/index');
const AREA_TEXT = require(path+'area/index');
const INVITE_BRAND_TEXT = require(path+'invite/brand/index');
const INVITE_USER_TEXT = require(path+'invite/inviteuser/index');
const EXPRESS_TEXT = require(path+'express/index');
const APPLY_VUE = new Vue;

const SHOP_TEXT = require(path+'shop/index');
const MY_TEXT = require(path+'my/index');
const ADDRESS_TEXT = require(path+'address/index');
const BANK_TEXT = require(path+'bank/index');
const TRANSFER_TEXT = require(path+'transfer/index');
const ORDERS_TEXT = require(path+'orders/index');
const REWARD_TEXT = require(path+'reward/index');
const REMIND_TEXT = require(path+'remind/index');


const AUDIT_BRAND_TEXT = require(path+'audit/brand/index');
const INVERLATIVE_BRAND_TEXT = require(path+'invrelative/brand/index');
const ACHIEVEMENT_TEXT = require(path+'achievement/index');
const STOCK_TEXT = require(path+'stock/index');
const TEAM_TEXT = require(path+'team/index');

const TITLE_TEXT = require(path+'title/index');//国际化顶部标题标签

function getErrrorMsg(key){
    return ERROR_TEXT.errorMsg[key]?ERROR_TEXT.errorMsg[key]:"";
}


//获取地址首位
function getAreaProvince(){
    var objs = AREA_TEXT["86"];
    var list = new Array;
    for(var key in objs){
        var item = {};
        item["code"] = key;
        item["name"] = objs[key];
        list.push(item);
    }
    return list;
}

function getAreaSub(province){
    var objs = AREA_TEXT[province];
    var list =  [];
    if(objs){
        for(var key in objs){
            var item = {};
            item["code"] = key;
            item["name"] = objs[key];
            list.push(item);
        }
    } 
    return list;
}

//获取大区
function getApplyAreaRegion(){
    var objs = APPLY_AREA_TEXT["0"];
    var list = new Array;
    for(var key in objs){
        var item = {};
        item["code"] = key;
        item["name"] = objs[key];
        list.push(item);
    }
    return list;
}

function getApplyAreaSub(province){
    var objs = APPLY_AREA_TEXT[province];
    var list =  [];
    if(objs){
        for(var key in objs){
            var item = {};
            item["code"] = key;
            item["name"] = objs[key];
            list.push(item);
        }
    } 
    return list;
}

//获取快递
function getExpress(){
    var objs = EXPRESS_TEXT["0"];
    var list = new Array;
    for(var key in objs){
        var item = {};
        item["code"] = key;
        item["name"] = objs[key];
        list.push(item);
    }
    return list;
}

export {
    getErrrorMsg,
    getAreaProvince,
    getExpress,
    getAreaSub,
    APPLY_VUE,
    LOGIN_TEXT,
    REGISTER_TEXT,
    AGENT_TEXT,

    APPLY_INDEX_TEXT,
    APPLY_STEP1_TEXT,
    APPLY_STEP5_TEXT,
    APPLY_STEP3_TEXT,
    APPLY_STEP4_TEXT,
    APPLY_STEP2_TEXT,
    INVITE_BRAND_TEXT,
    INVITE_USER_TEXT,
    SHOP_TEXT,
    MY_TEXT,
    ADDRESS_TEXT,
    BANK_TEXT,
    TRANSFER_TEXT,
    ORDERS_TEXT,
    REWARD_TEXT,
    AUDIT_BRAND_TEXT,
    INVERLATIVE_BRAND_TEXT,
    ACHIEVEMENT_TEXT,
    STOCK_TEXT,
    TEAM_TEXT,
    TITLE_TEXT,
    REMIND_TEXT,
    EXPRESS_TEXT,
    getApplyAreaRegion,
    getApplyAreaSub
}


// WEBPACK FOOTER //
// ./src/config/language.js